import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { DateValue } from '@mantine/dates';
import dayjs from '@/libs/dayjs';
import { getDefaultDateRangeForSessions } from '@/utils/filters';

interface IReportState {
    dateRange: [DateValue, DateValue];
    setDateRange: (dates: [DateValue, DateValue]) => void;
    getDateRangeValue: () => {
        from_datetime: string;
        to_datetime: string;
    };
}

const WEEK_IN_DAYS = 7;
const now = dayjs();
const weekAgo = now.subtract(WEEK_IN_DAYS, 'day');

const initialState = {
    dateRange: getDefaultDateRangeForSessions()
};

const useReportStore = create<IReportState>()(
    persist(
        (set, get) => ({
            ...initialState,
            setDateRange: (dates: [DateValue, DateValue]) => {
                if (dates[0] && dates[1]) {
                    set({
                        dateRange: [
                            dayjs(dates[0]).startOf('day').toDate(),
                            dayjs(dates[1]).endOf('day').toDate()
                        ]
                    });
                } else {
                    set({ dateRange: dates });
                }
            },
            getDateRangeValue: () => {
                const { dateRange } = get();
                return {
                    from_datetime:
                        dateRange[0]?.toISOString() ?? weekAgo.toISOString(),
                    to_datetime:
                        dateRange[1]?.toISOString() ?? now.toISOString()
                };
            }
        }),
        {
            name: 'report-store',
            storage: createJSONStorage(() => globalThis.sessionStorage),
            partialize: (state) => ({
                dateRange: state.dateRange
            }),
            version: 1,
            /* eslint-disable-next-line unicorn/consistent-function-scoping */
            onRehydrateStorage: () => (state) => {
                if (state) {
                    // Convert string dates back to Date objects when rehydrating
                    const dateRange = state.dateRange.map((date) =>
                        date ? new Date(date) : undefined
                    ) as [DateValue, DateValue];

                    state.dateRange = dateRange;
                }
            }
        }
    )
);

export default useReportStore;
